/**
 * Generated by orval 🍺
 * Do not edit manually.
 * Novelist API
 * Admin REST API
 * OpenAPI spec version: 9999eb1d882990f19e352fba26b6c3f62977c8a7
 */

export type CollectionSortRuleInDirection = typeof CollectionSortRuleInDirection[keyof typeof CollectionSortRuleInDirection];


export const CollectionSortRuleInDirection = {
  asc: 'asc',
  desc: 'desc',
} as const;
